import _ from 'lodash';

import { deserialiseFundingRequirements } from './deserialiseFundingRequirements';
import { deserialiseWaitForOtherGuarantorsFundingRequirements } from './FundingSteps';
import { deserialiseSignedDocuments } from './signDocumentAction/SignDocumentsHelper';

export type TFundingRequirementsSteps = ReturnType<
    typeof orderFundingRequirements
>;

function orderByPriority(
    funding_requirement:
        | ReturnType<typeof deserialiseFundingRequirements>[0]
        | ReturnType<typeof deserialiseSignedDocuments>[0]
        | ReturnType<
              typeof deserialiseWaitForOtherGuarantorsFundingRequirements
          >[0]
) {
    const PRIORITY_ORDER = {
        BANK_DETAILS: 1,
        UPLOAD_BANK_EVIDENCE: 2,
        PENNY_TRANSFER: 3,
        ONFIDO_VERIFICATION: 4,
        ONFIDO_VIDEO_VERIFICATION: 4,
        IDVERSE_VERIFICATION: 4,
        MAJOR_SHAREHOLDER_CHECK: 5,
        DEBIT_CARD: 6,
        UPLOAD_GEWERBESCHEIN: 7,
        master_loan_agreement: 8,
        guarantee: 9,
        COMMISSION_CONSENT: 10,
        APPLICANT_CALL: 12
    } satisfies Partial<Record<(typeof funding_requirement)['type'], number>>;
    const LOWEST_PRIORITY = 100;

    return (
        PRIORITY_ORDER[
            funding_requirement.type as keyof typeof PRIORITY_ORDER
        ] || LOWEST_PRIORITY
    );
}

export const orderFundingRequirements = (
    fundingRequirements: ReturnType<typeof deserialiseFundingRequirements>,
    loanDocuments: ReturnType<typeof deserialiseSignedDocuments>,
    waitForOtherGuarantorsFundingRequirements?: ReturnType<
        typeof deserialiseWaitForOtherGuarantorsFundingRequirements
    > | null
) => {
    const allFundingRequirements = [
        ...fundingRequirements,
        ...loanDocuments,
        ...(waitForOtherGuarantorsFundingRequirements ?? [])
    ];

    return _.orderBy(allFundingRequirements, orderByPriority, 'asc');
};
